import { colors } from '../colors'

export const stepper = {
  bgColor: colors.blue,
  color: colors.white,
}
